import { render, staticRenderFns } from "./imitate.vue?vue&type=template&id=44f68372"
import script from "./imitate.vue?vue&type=script&lang=js"
export * from "./imitate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports